var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOpened = function SvgEyeOpened(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_218_4916)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_218_4916",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_218_4916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0046 15.1538C13.0208 15.1538 13.8831 14.7981 14.5914 14.0868C15.2997 13.3754 15.6539 12.5117 15.6539 11.4955C15.6539 10.4793 15.2982 9.61708 14.5869 8.90875C13.8756 8.20042 13.0118 7.84625 11.9956 7.84625C10.9795 7.84625 10.1172 8.20192 9.4089 8.91325C8.70057 9.62458 8.3464 10.4883 8.3464 11.5045C8.3464 12.5207 8.70207 13.3829 9.4134 14.0913C10.1247 14.7996 10.9885 15.1538 12.0046 15.1538ZM12.0001 14.2C11.2501 14.2 10.6126 13.9375 10.0876 13.4125C9.56265 12.8875 9.30015 12.25 9.30015 11.5C9.30015 10.75 9.56265 10.1125 10.0876 9.5875C10.6126 9.0625 11.2501 8.8 12.0001 8.8C12.7501 8.8 13.3876 9.0625 13.9126 9.5875C14.4376 10.1125 14.7001 10.75 14.7001 11.5C14.7001 12.25 14.4376 12.8875 13.9126 13.4125C13.3876 13.9375 12.7501 14.2 12.0001 14.2ZM12.0029 18C9.8369 18 7.8629 17.4106 6.0809 16.2317C4.2989 15.0529 2.96432 13.4757 2.07715 11.5C2.96432 9.52433 4.29798 7.94708 6.07815 6.76825C7.85831 5.58942 9.8314 5 11.9974 5C14.1634 5 16.1374 5.58942 17.9194 6.76825C19.7014 7.94708 21.036 9.52433 21.9231 11.5C21.036 13.4757 19.7023 15.0529 17.9221 16.2317C16.142 17.4106 14.1689 18 12.0029 18ZM12.0001 17C13.8835 17 15.6126 16.5042 17.1876 15.5125C18.7626 14.5208 19.9668 13.1833 20.8001 11.5C19.9668 9.81667 18.7626 8.47917 17.1876 7.4875C15.6126 6.49583 13.8835 6 12.0001 6C10.1168 6 8.38765 6.49583 6.81265 7.4875C5.23765 8.47917 4.03348 9.81667 3.20015 11.5C4.03348 13.1833 5.23765 14.5208 6.81265 15.5125C8.38765 16.5042 10.1168 17 12.0001 17Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_218_4916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
};
export default SvgEyeOpened;